import React from 'react';
// components
import ItemHeader from './ItemHeader';
import QuickRepliesItem from './QuickRepliesItem';
// ui
import Icon from '@material-ui/core/Icon';

const QuickReplies = ({ obj, quickRepliesList, callbackFromParent }) => {
    // 아이템 갯수
    let hasItem = quickRepliesList.length;

    // 아이템 순서 변경 및 제거
    const callBackhandleItem = (action, itemsIdx) => {
        // 순서 변경
        if (action) {
            // 해당 아이템 뽑음
            let selectedItem = quickRepliesList.filter(
                num => num === quickRepliesList[itemsIdx]
            );
            selectedItem = [Object.assign({}, selectedItem[0])];

            // 핸들러
            if (action === 'up' && itemsIdx > 0) {
                quickRepliesList.splice(itemsIdx, 1);
                quickRepliesList.splice(itemsIdx - 1, 0, ...selectedItem);
            } else if (
                action === 'down' &&
                itemsIdx < quickRepliesList.length - 1
            ) {
                quickRepliesList.splice(itemsIdx, 1);
                quickRepliesList.splice(itemsIdx + 1, 0, ...selectedItem);
            } else if (action === 'copy') {
                if (hasItem < 10) {
                    quickRepliesList.splice(itemsIdx + 1, 0, ...selectedItem);
                }
            } else if (action === 'del') {
                quickRepliesList = quickRepliesList.filter(
                    num => num !== quickRepliesList[itemsIdx]
                );
            } else {
                console.log('no case');
            }
        }

        //변경된 데이터 넣음
        let resultObj = {
            version: '2.0',
            template: {
                outputs: obj.template.outputs,
                quickReplies: quickRepliesList
            }
        };

        //부모한테 전달
        callbackFromParent(resultObj);
    };

    // 아이템 삭제
    const handleDelQuick = e => {
        //변경된 데이터 넣음
        let resultObj = {
            version: '2.0',
            template: {
                outputs: obj.template.outputs
            }
        };
        //부모한테 전달
        callbackFromParent(resultObj);
    };

    //  아이템 버튼 변경
    let buttonsList = quickRepliesList ? [...quickRepliesList] : [];
    const changeBtn = (buttonObj, buttonIdx) => {
        buttonsList[buttonIdx] = buttonObj;

        //변경된 데이터 넣음
        let resultObj = {
            version: '2.0',
            template: {
                outputs: obj.template.outputs,
                quickReplies: buttonsList
            }
        };
        //부모한테 전달
        callbackFromParent(resultObj);
    };

    // 아이템 버튼 삭제
    const delBtn = buttonIdx => {
        buttonsList = buttonsList.filter(num => num !== buttonsList[buttonIdx]);

        //변경된 데이터 넣음
        let resultObj = {
            version: '2.0',
            template: {
                outputs: obj.template.outputs,
                quickReplies: buttonsList
            }
        };
        //부모한테 전달
        callbackFromParent(resultObj);
    };

    // 아이템 버튼 추가
    const handleAddQuickItem = e => {
        let newDate = {
            action: 'message',
            label: '버튼 설정',
            messageText: ''
        };
        //변경된 데이터 넣음
        let resultObj = {
            version: '2.0',
            template: {
                outputs: obj.template.outputs,
                quickReplies: [...buttonsList, newDate]
            }
        };
        //부모한테 전달
        callbackFromParent(resultObj);
    };

    // 아이템 리스트
    let list;
    if (quickRepliesList) {
        list = quickRepliesList.map(function(el, itemsIdx) {
            return (
                <div className="item-cont" key={itemsIdx}>
                    <ItemHeader
                        itemsIdx={itemsIdx}
                        callBackhandleItem={callBackhandleItem}
                        hasItem={hasItem}
                    />
                    <QuickRepliesItem
                        button={el}
                        buttonIdx={itemsIdx}
                        changeBtn={changeBtn}
                        delBtn={delBtn}
                    />
                </div>
            );
        });
    }

    return (
        <div className="contents-wrap quick">
            {/* 왼쪽 숫자 */}
            <div className="contents-number">
                <em className="quick">
                    <Icon>swap_calls</Icon>
                </em>
                <button type="button" className="del" onClick={handleDelQuick}>
                    <Icon>delete_outline</Icon>
                </button>
            </div>
            {/* 타이틀 */}
            <h2>바로 연결</h2>
            {/* 아이템 감싸는 영역 */}
            <div className="items-wrap quick">
                {list}
                {/* 바로연결 추가 */}
                {hasItem < 10 && (
                    <div className="item-cont">
                        <button
                            type="button"
                            className="add"
                            onClick={handleAddQuickItem}
                        >
                            <Icon>add_circle_outline</Icon>
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default QuickReplies;
